export default __webpack_public_path__ + "static/media/hero.5c32137d.jpg";